"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Version = void 0;
const Result_1 = require("../ValueObjects/Result");
class Version {
    static GetLatest(versions) {
        if (versions.length === 0)
            return undefined;
        let latest = new Version(0, 0, 0);
        versions.forEach((v) => {
            if (v.major > latest.major) {
                latest = v;
            }
            else if (v.major === latest.major) {
                if (v.minor > latest.minor) {
                    latest = v;
                }
                else if (v.minor === latest.minor) {
                    if (v.patch > latest.patch) {
                        latest = v;
                    }
                }
            }
        });
        return latest;
    }
    static GetLatestWithMajor(versions, major) {
        if (versions.length === 0)
            return undefined;
        let latest;
        for (const v of versions) {
            if (v.major !== major)
                continue;
            if (latest === undefined) {
                latest = v;
                continue;
            }
            if (v.minor > latest.minor) {
                latest = v;
            }
            else if (v.minor === latest.minor) {
                if (v.patch > latest.patch) {
                    latest = v;
                }
            }
        }
        return latest;
    }
    static GetLatestWithMajorMinor(versions, major, minor) {
        if (versions.length === 0)
            return undefined;
        let latest;
        for (const v of versions) {
            if (v.major !== major)
                continue;
            if (v.minor !== minor)
                continue;
            if (latest === undefined) {
                latest = v;
                continue;
            }
            if (v.patch > latest.patch) {
                latest = v;
            }
        }
        return latest;
    }
    static FromString(versionString) {
        const stringSplit = versionString.split(".");
        if (stringSplit.length !== 3) {
            const err = new Error(`Unable to parse version string: ${versionString} because it could not be split into 3 parts`);
            return (0, Result_1.reject)(err);
        }
        const major = parseInt(stringSplit[0], 10);
        const minor = parseInt(stringSplit[1], 10);
        const patchLabel = stringSplit[2];
        let patch = NaN;
        let label;
        const indexOfDash = patchLabel.indexOf("-");
        if (indexOfDash > 0) {
            const patchStr = patchLabel.substring(0, indexOfDash);
            patch = parseInt(patchStr, 10);
            label = patchLabel.substring(indexOfDash + 1);
        }
        else {
            patch = parseInt(patchLabel, 10);
        }
        if (isNaN(major)) {
            const err = new Error(`Unable to parse version string: ${versionString} because Major is not a number`);
            return (0, Result_1.reject)(err);
        }
        if (isNaN(minor)) {
            const err = new Error(`Unable to parse version string: ${versionString} because Minor is not a number`);
            return (0, Result_1.reject)(err);
        }
        if (isNaN(patch)) {
            const err = new Error(`Unable to parse version string: ${versionString} because Patch is not a number`);
            return (0, Result_1.reject)(err);
        }
        const version = new Version(major, minor, patch, label);
        return (0, Result_1.resolve)(version);
    }
    constructor(major, minor, patch, label) {
        this.toString = () => {
            if (this.label) {
                return `${this.major}.${this.minor}.${this.patch}-${this.label}`;
            }
            else {
                return `${this.major}.${this.minor}.${this.patch}`;
            }
        };
        this.equals = (otherVersion) => {
            if (otherVersion.major !== this.major)
                return false;
            if (otherVersion.minor !== this.minor)
                return false;
            if (otherVersion.patch !== this.patch)
                return false;
            if (otherVersion.label !== this.label)
                return false;
            return true;
        };
        this.major = major;
        this.minor = minor;
        this.patch = patch;
        this.label = label;
    }
}
exports.Version = Version;
